// extracted by mini-css-extract-plugin
module.exports = {"tab":"_4f720283bf--tab--DdCyn","active":"_4f720283bf--active--loeyw","disabled":"_4f720283bf--disabled--Wsp4S"};